import PropTypes from 'prop-types';
import StyleButton from "./StyleButton";
import { jsx as _jsx } from "react/jsx-runtime";
const INLINE_STYLES = [{
  label: 'B',
  style: 'BOLD'
}, {
  label: 'I',
  style: 'ITALIC'
}, {
  label: 'U',
  style: 'UNDERLINE'
}];
const InlineStyleControls = props => {
  const currentStyle = props.editorState.getCurrentInlineStyle();
  return /*#__PURE__*/_jsx("div", {
    className: "RichEditor-controls",
    children: /*#__PURE__*/_jsx("div", {
      className: "btn-group",
      role: "group",
      children: INLINE_STYLES.map(type => /*#__PURE__*/_jsx(StyleButton, {
        active: currentStyle.has(type.style),
        label: type.label,
        onToggle: props.onToggle,
        style: type.style
      }, type.style))
    })
  });
};
InlineStyleControls.propTypes = {
  editorState: PropTypes.object.isRequired,
  onToggle: PropTypes.func.isRequired
};
export default InlineStyleControls;
//# sourceMappingURL=InlineStyleControls.js.map